import script from "./JoinAsVendorForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinAsVendorForm.vue?vue&type=script&setup=true&lang=ts"

import "./JoinAsVendorForm.vue?vue&type=style&index=0&id=34cc57e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34cc57e1"]])

export default __exports__